export const alphabeticQuery = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
]
export const CompanyTable = [
    {label: "Company Name", prop: "companyName", type: "Name", width: 300, isFixed: false, align: "center"},
    {label: "Logo", prop: "businessLogo", type: "image", width: "", isFixed: false, align: "center"},
    // {label: "Website", prop: "stockCode", type: "website", width: "", isFixed: false, align: "center"},
    {label: "Industry", prop: "type", type: "industry", width: "", isFixed: false, align: "center"},
    // {label: "Address", prop: "listingLocation", type: "Location", width: "", isFixed: false, align: "center"},
    {label: "State", prop: "state", type: "Switch", width: "", isFixed: false, align: "center"},
    {
        label: "Operation",
        type: "Button",
        isFixed: "right",
        align: "center",
        btnList: [
            {
                type: "",
                label: "Edit",
                handle: row => "edit"
            },
            {
                type: "",
                label: "Delete",
                handle: row => "delete"
            }
        ]
    }
]

export const NewsTable = [
    {label: "Headlines", prop: "headlines", width: "", isFixed: false},
    {label: "Summary", prop: "summary", width: "", isFixed: false},
    {label: "News Source", prop: "newsSource", width: "", isFixed: false},
    {label: "Create time", prop: "createTime", width: 200, isFixed: false},
    {label: "State", prop: "state", type: "Switch", width: "", isFixed: false},
]

export const GroupTable = [
    {label: "EnglishName", prop: "EnglishName", type: "english", width: "", isFixed: false, align: "center"},
    {label: "ChineseName", prop: "ChineseName", type: "chinese", width: 200, isFixed: false, align: "center"},
    {label: "Update time", prop: "updateTime", type: "updateTime", width: 200, isFixed: false, align: "center"},
    {label: "State", prop: "state", type: "Switch3", width: "", isFixed: false, align: "center"},
    {
        label: "Operation",
        type: "Button",
        isFixed: "right",
        align: "center",
        btnList: [
            {
                type: "",
                label: "Edit",
                handle: row => "edit"
            },
            {
                type: "",
                label: "Delete",
                handle: row => "delete"
            }
        ]
    }
]

export const Tab2Column = [
    {label: "Headlines", field: "title", align: "center"},
    {label: "Summary", field: "summary", align: "center"},
    {label: "News Source", field: "source", align: "center"},
    {label: "Release time", field: "publish", align: "center"},
]